(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header')
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size'
      this.headerBounds = {}
      this.menuItems = document.querySelector('.header__inline-menu').querySelectorAll('details.mega-menu')
      this.megaMenuItems = document.querySelector('.header__inline-menu').querySelectorAll('details.mega-menu__child-link-menu')
      this.initMenuItems()
      this.setHeaderHeight()

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this))

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky')
      }

      this.currentScrollTop = 0
      this.preventReveal = false
      this.predictiveSearch = this.querySelector('predictive-search')

      this.onScrollHandler = this.onScroll.bind(this)
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.addEventListener('scroll', this.onScrollHandler, false)

      this.createObserver()
      this.initAutosuggestObserver()
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`)
    }

    initMenuItems() {
      if (this.menuItems) {
        this.menuItems.forEach((item) => {
          const summary = item.querySelector('summary')

          if (summary) {
            this.mainMenuLinkClick(summary)
          }

          let hoverTimeout
          let leaveTimeout
          let isMouseOver = false

          item.addEventListener('mouseenter', () => {
            clearTimeout(hoverTimeout)
            clearTimeout(leaveTimeout)
            isMouseOver = true

            const otherHoveredItem = document.querySelector('.is-hovered')
            if (otherHoveredItem && otherHoveredItem !== item) {
              hoverTimeout = setTimeout(() => {
                if (isMouseOver) {
                  item.classList.add('is-hovered')
                  item.setAttribute('open', true)
                  otherHoveredItem.classList.remove('is-hovered')
                  otherHoveredItem.removeAttribute('open')
                }
              }, 250)
            } else {
              hoverTimeout = setTimeout(() => {
                if (isMouseOver) {
                  item.classList.add('is-hovered')
                  item.setAttribute('open', true)
                }
              }, 250)
            }
          })

          item.addEventListener('mouseleave', () => {
            clearTimeout(hoverTimeout)
            isMouseOver = false

            leaveTimeout = setTimeout(() => {
              if (!isMouseOver) {
                item.classList.remove('is-hovered')
                item.removeAttribute('open')
              }
            }, 500)
          })
        })

        this.initMegaMenuItems()
      }
    }

    initMegaMenuItems() {
      if (this.megaMenuItems) {
        this.megaMenuItems.forEach((item) => {
          const summary = item.querySelector('summary')
          const contents = item.querySelector('.mega-menu__contents')
          const megaMenuRight = item.closest('.mega-menu').querySelector('.mega-menu__right')

          this.megaMenuLinkClick(summary)

          let hoverTimeout
          let leaveTimeout

          const originalContent = megaMenuRight.innerHTML

          const cloneContents = () => {
            megaMenuRight.innerHTML = ''
            const clonedContents = contents.cloneNode(true)
            clonedContents.classList.add('cloned')
            megaMenuRight.appendChild(clonedContents)
            clonedContents.style.display = 'grid'
            this.megaMenuLinkHover(clonedContents)
          }

          const restoreOriginalContent = () => {
            megaMenuRight.innerHTML = originalContent
          }

          const handleHover = () => {
            clearTimeout(leaveTimeout)
            hoverTimeout = setTimeout(() => {
              item.setAttribute('open', true)
              item.classList.add('is-hovered')
              cloneContents()
            }, 500)
          }

          const handleLeave = () => {
            clearTimeout(hoverTimeout)
            leaveTimeout = setTimeout(() => {
              if (!megaMenuRight.matches(':hover') && !summary.matches(':hover')) {
                item.removeAttribute('open')
                item.classList.remove('is-hovered')
                restoreOriginalContent()
              }
            }, 500)
          }

          summary.addEventListener('mouseenter', handleHover)
          summary.addEventListener('mouseleave', handleLeave)
          megaMenuRight.addEventListener('mouseenter', () => clearTimeout(leaveTimeout))
          megaMenuRight.addEventListener('mouseleave', handleLeave)
        })

        this.megaMenuColumns()
        this.megaMenuLinkHover()
      }
    }

    megaMenuColumns() {
      const navList = document.querySelectorAll('.mega-menu__child-list')
      const itemsPerColumn = 13

      navList.forEach((list) => {
        const items = list.getElementsByTagName('li')

        for (let i = 0; i < items.length; i++) {
          const column = Math.floor(i / itemsPerColumn) + 1
          const row = (i % itemsPerColumn) + 1

          items[i].style.gridColumn = column
          items[i].style.gridRow = row
        }
      })
    }

    megaMenuLinkHover() {
      const linksWithImage = document.querySelectorAll('.mega-menu__child-list .mega-menu__grandchild-link > a[data-image]')
      const megaMenuImages = document.querySelectorAll('.mega-menu-image > img')

      megaMenuImages.forEach((image) => {
        image.dataset.originalSrc = image.getAttribute('src') || ''
        image.dataset.originalSrcset = image.getAttribute('srcset') || ''
      })

      let hoverTimeout

      linksWithImage.forEach((link) => {
        const imageUrl = link.getAttribute('data-image')

        link.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimeout)

          hoverTimeout = setTimeout(() => {
            const menuImage = link.closest('.mega-menu__contents')?.querySelector('.mega-menu-image > img')

            if (menuImage) {
              if (imageUrl) {
                menuImage.setAttribute('src', imageUrl)
                menuImage.setAttribute('alt', link.textContent.trim())

                if (menuImage.srcset) {
                  menuImage.setAttribute('srcset', imageUrl)
                } else {
                  menuImage.removeAttribute('srcset')
                }
              } else {
                menuImage.setAttribute('src', menuImage.dataset.originalSrc)
                menuImage.setAttribute('srcset', menuImage.dataset.originalSrcset)
              }
            }
          }, 250)
        })

        link.addEventListener('mouseleave', () => {
          clearTimeout(hoverTimeout)
          hoverTimeout = setTimeout(() => {
            const menuImage = link.closest('.mega-menu__contents')?.querySelector('.mega-menu-image > img')

            if (menuImage) {
              menuImage.setAttribute('src', menuImage.dataset.originalSrc)
              menuImage.setAttribute('srcset', menuImage.dataset.originalSrcset)
              menuImage.setAttribute('alt', '')
            }
          }, 250)
        })
      })
    }

    megaMenuLinkClick(summary) {
      const link = summary.dataset.link
      if (!link) return

      if (link) {
        summary.addEventListener('click', (e) => {
          e.preventDefault()
          if (e.metaKey || e.ctrlKey) {
            window.open(link, '_blank')
          } else {
            window.location.href = link
          }
        })
      }
    }

    mainMenuLinkClick(summary) {
      const link = summary.dataset.link
      if (!link) return

      summary.addEventListener('click', (e) => {
        e.preventDefault()
        if (e.metaKey || e.ctrlKey) {
          window.open(link, '_blank')
        } else {
          window.location.href = link
        }
      })
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.removeEventListener('scroll', this.onScrollHandler)
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect
        observer.disconnect()
      })

      observer.observe(this.header)
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header')
        if (this.preventHide) return
        requestAnimationFrame(this.hide.bind(this))
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header')
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this))
        } else {
          window.clearTimeout(this.isScrolling)

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false
          }, 66)

          requestAnimationFrame(this.hide.bind(this))
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header')
        requestAnimationFrame(this.reset.bind(this))
      }

      this.currentScrollTop = scrollTop
    }

    hide() {
      if (this.headerIsAlwaysSticky) return
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
      this.closeMenuDisclosure()
      this.closeSearchModal()
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return
      this.header.classList.add('shopify-section-header-sticky', 'animate')
      this.header.classList.remove('shopify-section-header-hidden')
    }

    reset() {
      if (this.headerIsAlwaysSticky) return
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate')
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu')
      this.disclosures.forEach((disclosure) => disclosure.close())
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal')
    }

    updateAutosuggestBodyClass() {
      const autosuggestElements = document.querySelectorAll('.blm-autosuggest-search-results');

      if (autosuggestElements.length > 0) {
        const hasAnyChildren = Array.from(autosuggestElements).some(element => element.children.length > 0);

        if (hasAnyChildren) {
          document.body.classList.add('blm-autosuggest-search-results--active');
        } else {
          document.body.classList.remove('blm-autosuggest-search-results--active');
        }
      } else {
        document.body.classList.remove('blm-autosuggest-search-results--active');
      }
    }

    initAutosuggestObserver() {
      this.autosuggestObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const autosuggestElements = document.querySelectorAll('.blm-autosuggest-search-results');
            if (autosuggestElements.length > 0) {
              this.updateAutosuggestBodyClass();
            }
          }
        });
      });

      this.autosuggestObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      const autosuggestElements = document.querySelectorAll('.blm-autosuggest-search-results');
      autosuggestElements.forEach(element => {
        this.autosuggestObserver.observe(element, {
          childList: true,
          subtree: true
        });
      });

      this.updateAutosuggestBodyClass();
    }
  }

  customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();
})();
